import React from 'react';
import TaskEditorWrapper from 'containers/Tasks/TasksManagement/TaskEditorWrapper';
import { IField } from 'store/tasks/tasksType';
import { languageDirection } from '../../../../i18n';
import { ITaskSurveyResponse } from '../../../../components/FileManager/ItemsViewer/Survey/SurveyResponseViewer/ResponseItem';
import { ITagView } from '../../../../store/providers/providerTypes';

// Have to set any type to TaskEditorWrapper because of a bug that described in bellow link
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/16990
const AnyTaskEditorWrapper: any = TaskEditorWrapper;

interface IComponentProps {
  companyId?: number;
  templateId?: number;
  providerItem?: any;
  tab: string;
  taskId?: number | 'new';
  onTaskCreate?: (taskId: number) => any;
  onClose?: () => void;
  fields?: IField[];
  taskSurveyResponse?: ITaskSurveyResponse;
  tags?: { [p: number]: ITagView } | null | undefined;
  disableStack?: boolean | undefined;
  zIndex?: number;
}

class ItemTask extends React.PureComponent<IComponentProps> {
  render() {
    const responseItem = this.props.taskSurveyResponse?.reponseItem;
    const surveyVersion = this.props.taskSurveyResponse?.surveyItem;

    const questionConfigs = surveyVersion?.questionMap
      ? Object.values(surveyVersion.questionMap)
      : [];
    const responses = responseItem?.surveyAnswerList || [];

    const matchedFields = questionConfigs.reduce((acc: any, question: any) => {
      const response = responses.find((r: any) => r.questionId === question.id);
      if (response && question.fields) {
        const relatedField = question.fields.find(
          (f: any) => f.name === 'conf_related_field'
        );
        if (relatedField) {
          try {
            const fieldConfig = JSON.parse(relatedField.value || '{}');

            if (
              this.props.templateId?.toString() &&
              fieldConfig?.[this.props.templateId.toString()]
            ) {
              let fieldValue;

              if (response.type === 'multipleChoice') {
                if (question.useTags) {
                  fieldValue = response.selected?.map(
                    (val: any) =>
                      Object.values(this.props?.tags || {}).find(
                        (tag: any) => tag.id === val
                      )?.text || val
                  );
                } else {
                  fieldValue = response.values?.map(
                    (val: any) =>
                      question.choiceList?.find(
                        (choice: any) => choice.value === val
                      )?.text || val
                  );
                }
                acc[fieldConfig[this.props.templateId.toString()]] = fieldValue;
              } else {
                fieldValue = response.value;
                acc[fieldConfig[this.props.templateId.toString()]] = [
                  fieldValue,
                ];
              }
            }
          } catch (e) {
            console.error('Error parsing field config:', e);
          }
        }
      }
      return acc;
    }, {});
    const side = languageDirection() === 'rtl' ? 'left' : 'right';
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          position: 'fixed',
          top: 0,
          [side]: 0,
          zIndex: 10000 + (this.props?.zIndex ?? 0),
          height: '100%',
        }}
      >
        <AnyTaskEditorWrapper
          {...this.props}
          embedded={true}
          autoFillFields={matchedFields}
        />
      </div>
    );
  }
}

export default ItemTask;
